import { render, staticRenderFns } from "./RealworksCredentials.vue?vue&type=template&id=12dfbec4&"
import script from "./RealworksCredentials.vue?vue&type=script&lang=ts&"
export * from "./RealworksCredentials.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports